import { Box, Checkbox, Container, FormControlLabel, FormGroup, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import './PatientInitWizardStep.css';

import { useSelector } from 'react-redux';
import * as yup from 'yup';
import { RootState } from '../../store/store';
import InfoBox from '../ui/DaliaComponents';
import WizardStep from '../ui/WizardStep';

const PatientInitStepInclusion: WizardStep = ({ formik }) => {
  const { profile } = useSelector((state: RootState) => state.auth);

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = event.target;
    const newInclusionCriteria = checked
      ? [...(formik.values.inclusionCriteria || []), name]
      : formik.values.inclusionCriteria?.filter((criteria: string) => criteria !== name);
    formik.setFieldValue('inclusionCriteria', newInclusionCriteria);
  };

  return (
    <Container>
      <InfoBox emoji="⚠️">
        Un patient ne peut être inclu dans l&apos;étude que s&apos;il remplit tous les critères d&apos;inclusion et tous les critères d&apos;exclusion
      </InfoBox>
      <Box sx={{ mt: 4 }}>
        <Grid container>
          <Grid size={12}>
            &#128073; Cochez si le patient respecte les critères suivants :
            <FormGroup sx={{ mt: 1 }}>
              {profile?.hospital?.study?.inclusionCriteria.map((criteria, index) => (
                <FormControlLabel
                  control={<Checkbox checked={formik.values.inclusionCriteria?.includes(criteria)} name={criteria} onChange={handleCheckboxChange} />}
                  key={`criteria-${index}`}
                  label={criteria}
                />
              ))}
            </FormGroup>
          </Grid>
          <Grid size={12} sx={{ mt: 2 }}>
            {!formik.isValid && formik.touched && (
              <Typography align="center" color="error">
                Tous les critères doivent etre cochés
              </Typography>
            )}
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};
PatientInitStepInclusion.label = "Critères d'inclusion";

PatientInitStepInclusion.initialValues = {
  inclusionCriteria: [],
};

// all inclusion criteria must be checked
PatientInitStepInclusion.validationSchema = (profile) => {
  const inclusionCriteriaOptions = profile?.hospital?.study?.inclusionCriteria || [];
  return yup.object().shape({
    inclusionCriteria: yup.array().min(inclusionCriteriaOptions.length, 'Tous les critères doivent être cochés'),
  });
};

export default PatientInitStepInclusion;